module.exports = __webpack_public_path__ + "assets/fonts/GothamPro-BoldItalic.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/gothampro/GothamPro-BoldItalic.woff
// module id = 1895
// module chunks = 0